<template>
  <!-- 首页-->
  <div class="home">
    <div class="head">
      <img src="../assets/head.png" alt class="backImg"/>
      <div class="head_logo">
        <img src="../assets/head_logo.png" alt/>
      </div>
      <div class="head_title">微观资讯后台管理系统</div>
      <div class="head_people">
        <img src="../assets/people.png" alt/>
      </div>

      <div class="head_btn">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <span>{{ $store.state.name }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                style="height: 20px; font-size: 10px; line-height: 20px"
                command="back"
            >退出登录
            </el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="content">
      <div class="left_index">
        <el-col>
          <a-menu
              :open-keys="openKeys"
              mode="inline"
              theme="dark"
              :inline-collapsed="collapsed"
              @click="onOpenClick"
              @openChange="onOpenChange"
          >
            <!--            内容管理-->
            <a-sub-menu key="sub1" v-if="menuData.includes('/content/microcosmicinfo')
            ||menuData.includes('/content/microcosmicvideo')
            ||menuData.includes('/content/special')
            ||menuData.includes('/content/frequency')
            ||menuData.includes('/content/video')">
                <span slot="title">
                  <a-icon type="bars"/>
                  <span>内容管理</span>
                </span>
              <a-menu-item v-if="menuData.includes('/content/microcosmicinfo')">
                <router-link to="/informationManageList">
                  <a-icon type="read"/>
                  <span>微观号资讯管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/content/microcosmicvideo')">
                <router-link to="/">
                  <a-icon type="play-square"/>
                  <span>微观号视频管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/content/special')">
                <!--                <router-link to="/topic">-->
                <router-link to="/thematicManagementList">
                  <a-icon type="star"/>
                  <span>专题管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/content/frequency')">
                <router-link to="/audio">
                  <a-icon type="audio"/>
                  <span>音频管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/content/video')">
                <router-link to="/videoManageList">
                  <a-icon type="video-camera"/>
                  <span>视频管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/topicManageList">
                  <a-icon type="read"/>
                  <span>话题管理</span>
                </router-link>
              </a-menu-item>


            </a-sub-menu>
            <!--            广告管理-->
            <a-sub-menu key="sub2" v-if="menuData.includes('/advertisement/openscreen')
            ||menuData.includes('/advertisement/focus')
            ||menuData.includes('/advertisement/information')
            ||menuData.includes('/advertisement/article')
            ||menuData.includes('/advertisement/share')">
                <span slot="title">
                  <a-icon type="bars"/>
                  <span>广告管理</span>
                </span>
              <a-menu-item v-if="menuData.includes('/advertisement/openscreen')">
                <router-link to="/openScreenList">
                  <a-icon type="picture"/>
                  <span>开屏广告</span>
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/longImageList">
                  <a-icon type="picture"/>
                  <span>长图广告</span>
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/pageImageList">
                  <a-icon type="picture"/>
                  <span>页面广告</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/advertisement/focus')">
                <router-link to="/">
                  <a-icon type="play-square"/>
                  <span>焦点图广告</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/advertisement/information')">
                <router-link to="/">
                  <a-icon type="play-square"/>
                  <span>信息流广告</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/advertisement/article')">
                <router-link to="/">
                  <a-icon type="play-square"/>
                  <span>文章页广告</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/advertisement/share')">
                <router-link to="/">
                  <a-icon type="play-square"/>
                  <span>分享页广告</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
            <!--            商城管理-->
            <a-sub-menu key="sub3" v-if="menuData.includes('/shopping/commodity')
            ||menuData.includes('/shopping/order')
            ||menuData.includes('/shopping/classification')
            ||menuData.includes('/shopping/customer')
            ||menuData.includes('/shopping/rotation')">
                <span slot="title">
                  <a-icon type="bars"/>
                  <span>商城管理</span>
                </span>
              <a-menu-item v-if="menuData.includes('/shopping/commodity')">
                <router-link to="/shoppingMall">
                  <a-icon type="shop"/>
                  <span>商品管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/shopping/order')">
                <router-link to="/orderList">
                  <a-icon type="bars"/>
                  <span>订单管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/shopping/classification')">
                <router-link to="/scType">
                  <a-icon type="ordered-list"/>
                  <span>分类管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/shopping/customer')">
                <router-link to="/weChat">
                  <a-icon type="usb"/>
                  <span>客服管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/shopping/rotation')">
                <a-sub-menu key="sub9">
                  <span slot="title">
                    <a-icon type="picture"/>
                    <span>商城轮播</span>
                  </span>
                  <a-menu-item
                      :class="{ check: indexII == current2 }"
                      v-for="(itemII, indexII) in shopList"
                      :key="indexII"
                      @click="goShop(itemII, indexII)"
                  >{{ itemII.name }}
                  </a-menu-item>
                </a-sub-menu>
              </a-menu-item>
            </a-sub-menu>
            <!--            楼盘管理-->
            <a-sub-menu key="sub4" v-if="menuData.includes('/floor/propertiesforsale')
            ||menuData.includes('/floor/information')
            ||menuData.includes('/floor/videoroomsearch')
            ||menuData.includes('/floor/manager')
            ||menuData.includes('/floor/search')">
                <span slot="title">
                  <a-icon type="bars"/>
                  <span>楼盘管理</span>
                </span>
              <a-menu-item v-if="menuData.includes('/floor/propertiesforsale')">
                <router-link to="/house">
                  <a-icon type="environment"/>
                  <span>楼盘管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/floor/information')">
                <router-link to="/houseInfo">
                  <a-icon type="profile"/>
                  <span>楼盘信息</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/floor/videoroomsearch')">
                <router-link to="/floorVideo">
                  <a-icon type="play-square"/>
                  <span>视频找房</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/floor/manager')">
                <router-link to="/salesman">
                  <a-icon type="idcard"/>
                  <span>职业经理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/floor/search')">
                <router-link to="/floorSearch">
                  <a-icon type="search"/>
                  <span>房产搜索榜单</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
            <!--            考勤管理-->
            <a-sub-menu key="sub5" v-if="menuData.includes('/attendance/fieldpersonnel')">
                <span slot="title">
                  <a-icon type="bars"/>
                  <span>考勤管理</span>
                </span>
              <a-menu-item v-if="menuData.includes('/attendance/fieldpersonnel')">
                <router-link to="/clock">
                  <a-icon type="environment"/>
                  <span>外勤管理</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
            <!--            审核管理-->
            <a-sub-menu key="sub6" v-if="menuData.includes('/examine/microcosmicinfo')
              ||menuData.includes('/examine/microcosmicvideo')
              ||menuData.includes('/examine/dynamic')
              ||menuData.includes('/examine/special')
              ||menuData.includes('/examine/audiofrequency')
              ||menuData.includes('/examine/video')
              ||menuData.includes('/examine/luckdraw')
              ||menuData.includes('/examine/handNews')">
                <span slot="title">
                  <a-icon type="bars"/>
                  <span>审核管理</span>
                </span>
              <a-menu-item v-if="menuData.includes('/examine/microcosmicinfo')">
                <router-link to="/newsList">
                  <a-icon type="read"/>
                  <span>微观号资讯审核</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/examine/microcosmicvideo')">
                <router-link to="/videoList">
                  <a-icon type="play-square"/>
                  <span>微观号视频审核</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/examine/dynamic')">
                <router-link to="/dynamicList">
                  <a-icon type="read"/>
                  <span>动态审核</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/examine/special')">
                <router-link to="/thematicList">
                  <a-icon type="read"/>
                  <span>专题审核</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/examine/audiofrequency')">
                <router-link to="/">
                  <a-icon type="read"/>
                  <span>音频审核</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/examine/video')">
                <router-link to="/videoAuditList">
                  <a-icon type="read"/>
                  <span>视频审核</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/examine/luckdraw')">
                <router-link to="/">
                  <a-icon type="read"/>
                  <span>抽奖审核</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/examine/message')">
                <router-link to="/messageList">
                  <a-icon type="read"/>
                  <span>留言审核</span>
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/topicList">
                  <a-icon type="read"/>
                  <span>话题审核</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/examine/handNews')">
                <router-link to="/banshouliAuditList">
                  <a-icon type="read"/>
                  <span>伴手礼审核</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
            <!--            活动管理-->
            <a-sub-menu key="sub7"
                        v-if="menuData.includes('/activity/luckdraw')||menuData.includes('/activity/povertyalleviation')||menuData.includes('/activity/vote')||menuData.includes('/activity/questionnaire')||menuData.includes('/activity/together')||menuData.includes('/activity/handNews')||menuData.includes('/activity/education')">
                <span slot="title">
                  <a-icon type="bars"/>
                  <span>活动管理</span>
                </span>
              <a-menu-item v-if="menuData.includes('/activity/handNews')">
                <router-link to="/banshouliList">
<!--                  <a-icon type="trophy"/>-->
                  <img src="../assets/banshouli.png" style="width: 16px;height:16px;margin-right: 8px"/>
                  <span>伴手礼管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/activity/luckdraw')">
                <router-link to="/lucky">
                  <a-icon type="trophy"/>
                  <span>抽奖管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/activity/povertyalleviation')">
                <router-link to="/poor">
                  <a-icon type="notification"/>
                  <span>扶贫管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/activity/vote')">
                <router-link to="/voteList">
                  <a-icon type="like"/>
                  <span>投票管理</span>
                </router-link>
<!--                <router-link to="/vote">-->
<!--                  <a-icon type="like"/>-->
<!--                  <span>投票管理</span>-->
<!--                </router-link>-->
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/activity/questionnaire')">
                <router-link to="/wj">
                  <a-icon type="table"/>
                  <span>问卷管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/activity/together')">
                <router-link to="/callUp">
                  <a-icon type="pie-chart"/>
                  <span>召集令管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/broadcast">
                  <a-icon type="file-image"/>
                  <span>图文直播管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/activity/education')">
                <router-link to="/eduVoteList">
                  <img src="../assets/banshouli.png" style="width: 16px;height:16px;margin-right: 8px"/>
                  <span>教委投票管理</span>
                </router-link>
              </a-menu-item>

            </a-sub-menu>
            <!--            系统管理-->
            <a-sub-menu key="sub8"
                        v-if="menuData.includes('/system/user')||menuData.includes('/system/role')||menuData.includes('/system/role')||menuData.includes('/system/jurisdiction')||menuData.includes('/system/entrance')">
                <span slot="title">
                  <a-icon type="setting"/>
                  <span>系统管理</span>
                </span>
              <a-menu-item v-if="menuData.includes('/system/user')">
                <router-link to="/userList">
                  <a-icon type="user"/>
                  <span>用户管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/system/role')">
                <router-link to="/roleList">
                  <a-icon type="team"/>
                  <span>角色管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/system/role')">
                <router-link to="/pageList">
                  <a-icon type="menu"/>
                  <span>页面管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/system/jurisdiction')">
                <router-link to="/permissionList">
                  <a-icon type="cluster"/>
                  <span>权限管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item v-if="menuData.includes('/system/entrance')">
                <router-link to="/system">
                  <a-icon type="pie-chart"/>
                  <span>入口管理</span>
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/reportAnnouncementList">
                  <a-icon type="pie-chart"/>
                  <span>举报公告</span>
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/reportList">
                  <a-icon type="pie-chart"/>
                  <span>举报管理</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </el-col>
      </div>
      <div class="right_index">
        <div class="bottom">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: "2",
      collapsed: false,
      openKeys: [""],
      rootSubmenuKeys: [""],
      menuData: [],
      shopList: [], //商城轮播管理
      current2: 0,
    };
  },
  methods: {
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
          (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    subMenuTap(item) {
      console.log(item, '当前点击的一级菜单')
    },
    menuTap(item) {
      console.log(item, '当前点击的二级菜单')
    },
    onOpenClick(item, key) {
      console.log(item, key, 999)
    },
    //退出登录：
    handleCommand(command) {
      if (command == "back") {
        this.$router.push("/");
        localStorage.removeItem("key"); //清空token
      }
    },
    goShop(item, index) {
      this.current2 = index;
      this.$router.push({path: "/shopList", query: {obj: item}});
    },
  },
  created() {
    this.menuData = []
    if (this.$store.state.menuPermission && this.$store.state.menuPermission.length) {
      this.$store.state.menuPermission.forEach((item) => {
        this.menuData.push(item.page_code)
      })
    }
    this.getAxios("/sc/rotation/listLocation").then((res) => {
      this.shopList = res.content;
    });
  },
};
</script>
<style scoped lang="less">
.home {
  width: 100%;
  overflow: hidden;

  .head {
    width: 100%;
    height: 70px;
    position: relative;
    // display: flex;
    float: left;
    top: 0;

    &:after {
      content: "";
      clear: both;
      display: block;
    }

    .backImg {
      width: 100%;
      height: 100%;
      // display: flex;
      transform: rotate(180deg);
    }

    .head_logo {
      height: 70px;
      width: 90px;
      float: left;
      position: absolute;
      top: 0;

      img {
        height: 41px;
        width: auto;
        margin-left: 28px;
        top: -50%;
        margin-top: 15px;
      }
    }

    .head_title {
      width: 430px;
      height: 70px;
      line-height: 70px;
      letter-spacing: 12px;
      margin-left: 139px;
      // margin-top: -40px;
      font-size: 30px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #ffffff;
      position: absolute;
      top: 0;
    }

    .head_email {
      width: 26px;
      height: 70px;
      // margin-left: 800px;
      // background: red;
      float: left;
      position: absolute;
      top: 0;
      right: 293px;

      img {
        width: 26px;
        height: 18px;
        top: -50%;
        margin-top: 25px;
      }
    }

    .head_bell {
      width: 26px;
      height: 70px;
      // margin-left: 800px;
      // background: red;
      float: left;
      position: absolute;
      top: 0;
      right: 241px;

      img {
        width: auto;
        height: 18px;
        top: -50%;
        margin-top: 25px;
      }
    }

    .head_expend {
      width: 26px;
      height: 70px;
      // margin-left: 800px;
      // background: red;
      float: left;
      position: absolute;
      top: 0;
      right: 185px;

      img {
        width: auto;
        height: 18px;
        top: -50%;
        margin-top: 25px;
      }
    }

    .head_people {
      width: 47px;
      height: 70px;
      // margin-left: 800px;
      // background: red;
      float: left;
      position: absolute;
      top: 0;
      right: 130px;

      img {
        width: auto;
        height: 47px;
        top: -50%;
        margin-top: 13px;
      }
    }

    .head_btn {
      width: auto;
      height: 30px;
      float: left;
      position: absolute;
      top: 20px;
      right: 15px;

      span {
        width: auto;
        height: 9px;
        line-height: 30px;
        font-size: 12px;
        font-family: Arial;
        font-weight: 400;
        color: #ffffff;
      }
    }

    /deep/ .el-dropdown-menu__item {
      list-style: none;
      line-height: 10px;
      padding: 0 20px;
      margin: 0;
      font-size: 10px;
      color: #606266;
      cursor: pointer;
      outline: 0;
      height: 20px !important;
    }
  }

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    top: -1px;

    .left_index {
      // width: 200px;
      // min-height: 900px;
      // min-height: 900px;
      position: fixed;
      top: 69px;
      bottom: 0;
      left: 0;
      width: 210px;
      // height: 100%;
      border-right: 1px solid #e4e6e9;
      background: #001529;
      overflow-x: hidden;

      .el-col {
        height: 100%;

        .el-menu {
          height: 100%;
          border-right: solid 1px #e6e6e6;
          list-style: none;
          position: relative;
          margin: 0;
          padding-left: 0;
          background-color: #fff;
        }
      }
    }

    .right_index {
      // flex: 1;
      // flex-direction: column;
      // overflow: auto;
      // position: relative;
      // overflow-x: hidden;

      flex: 1;
      flex-direction: column;
      position: relative;
      overflow-y: auto;
      position: fixed;
      top: 69px;
      bottom: 0;
      left: 200px;
      //z-index: 9999;
      width: calc(100% - 210px);
      border-right: 1px solid #e4e6e9;
      background-color: #fff;

      .head_index {
        width: 100%;
        height: 50px !important;
        background: #5584ff;
        color: #fff;
        position: sticky;
        top: 0px;
        z-index: 1000;
        display: flex;
        position: absolute;

        p {
          &:nth-child(1) {
            line-height: 50px;
            position: absolute;
            //  right: 850px;
            right: 400px;
          }

          &:nth-child(2) {
            line-height: 50px;
            position: absolute;
            right: 200px;
          }

          &:nth-child(3) {
            line-height: 50px;
            text-align: right;
            position: absolute;
            right: 100px;
            cursor: pointer;
          }
        }
      }

      .bottom {
        width: 100%;
        height: 100%;
        margin-top: 5px;
      }
    }
  }
}

.bannerList {
  margin: 0 20px 20px 20px;
}

.check {
  color: #fff !important;
}

/deep/ .el-notification.right {
  z-index: 999999 !important;
}

/deep/ .el-menu-item-group__title {
  display: none;
}

/deep/ .el-col-24 {
  width: 95% !important;
}

/deep/ .ant-menu-item-selected a {
  color: #fff;
}

/* 滚动槽 */
</style>
